<template>
  <el-dialog :title="dialogName" :class="[currentTheme]" :visible.sync="dialogVisible" class="no-header-dialog" :close-on-click-modal="false" width="100%" :fullscreen="true" append-to-body>
    <div class="main-box">
      <xr-table ref="xrTable" :configure="configure">
        <template slot="listParam">
          <el-form ref="dataForm" :inline="true" id="dataForm" :model="configure.listParam" label-suffix="：" class="main-table-form">
            <el-form-item label="字典名称">
              <el-input v-model="configure.listParam.dictType" style="width: 200px;" placeholder="" disabled></el-input>
            </el-form-item>
            <el-form-item label="字典标签">
              <el-input v-model="configure.listParam.dictLabel" style="width: 200px;" placeholder="" @keyup.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="configure.listParam.status" style="width: 150px;" placeholder="">
                <el-option label="" value=""></el-option>
                <el-option label="正常" value="1"></el-option>
                <el-option label="停用" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="th-button" @click="search"><i class="wk wk-search"/><span>查询</span></div>
            </el-form-item>
            <el-form-item>
              <div class="th-button" @click="refreshData"><i class="wk wk-refresh"/><span>重置</span></div>
            </el-form-item>
          </el-form>
        </template>
      </xr-table>
    </div>

    <medical-dict-info ref="medicalDictInfo" v-if="isMedicalDictInfoShow" @refreshData="refreshData"></medical-dict-info>
  </el-dialog>
</template>

<script>
import MedicalDictInfo from './medical_dict_info.vue';
export default {
  name: "medicalDictIndex",
  components: {
    MedicalDictInfo
  },
  data() {
    return {
      dialogName: '字典维护',
      dialogVisible: false,
      isMedicalDictInfoShow: false,
      configure: {
        url: '/web/service?method=tCoreMedicalDict_list',
        listParam: {
          dictType: '',
          dictLabel: '',
          status: ''
        },
        pageSize: 10,
        tableHeight: 500,
        that: this,
        defaultNoLoadData: true,
        columns: [
          {
            field: 'ck',
            width: 60
          },
          {
            field: 'orgName',
            title: '机构名称',
            condition: {
              searchType: 'input',
              searchName: 'orgNameSearch',
              value: ''
            }
          },
          {
            field: 'dictCode',
            title: '字典编码',
            condition: {
              searchType: 'input',
              searchName: 'dictLabel',
              value: ''
            },
          },
          {
            field: 'dictLabel',
            title: '字典标签',
            condition: {
              searchType: 'input',
              searchName: 'dictLabelSearch',
              value: ''
            },
            formatter:function(value){
              return '<span class="tag el-tag el-tag--default el-tag--mini">'+value+'</span>'
            }
          },
          {
            field: 'dictValue',
            title: '字典健值',
            width: 100,
            condition: {
              searchType: 'input',
              searchName: 'dictValueSearch',
              value: ''
            }
          },
          {
            field: 'dictSort',
            title: '字典排序',
            width: 100,
            condition: {
              searchType: 'input',
              searchName: 'dictSortSearch',
              value: ''
            }
          },
          {
            field: 'status',
            title: '状态',
            width: 80,
            align: 'center',
            condition: {
              searchType: 'select',
              searchName: 'statusSearch',
              value: '',
              selectList: [
                { value: '', label: '' },
                { value: '0', label: '正常' },
                { value: '1', label: '停用' }
              ]
            },
            formatter:function(value,row){
              let result = ''
              if(row.status =='0'){
                result +='<span class="tag el-tag el-tag--default el-tag--mini">正常</span>'
              }
              if(row.status =='1'){
                result +='<span class="tag el-tag el-tag--danger el-tag--mini">停用</span>'
              }
              return result;
            }
          },
          {
            field: 'remark',
            title: '备注',
            width: 200,
            condition: {
              searchType: 'input',
              searchName: 'remarkSearch',
              value: ''
            }
          },
          {
            field: 'createTime',
            title: '创建时间',
            width: 180,
            condition: {
              searchType: 'input',
              searchName: 'createTimeSearch',
              value: ''
            }
          },
          {
            field: 'operate',
            title: '操作',
            cellType: 'operate',
            align: 'center',
            that: this,
            width: 300,
            operateList: [

              {
                text: '修改',
                iconCls: 'wk wk-edit',
                that: this,
                handler: function (row) {
                  this.that.handlerMedicalDictEdit(row);
                },
                display:function(row){
                  return this.that.currentOrgId == row.orgId
                }
              },
              {
                text: '删除',
                iconCls: 'wk wk-danger',
                that: this,
                display:function(row){
                  return this.that.currentOrgId == row.orgId
                },
                handler: function (row) {
                  this.that.handlerMedicalDictDelete(row);
                }
              },
            ]
          }
        ],
        toolbar: [
          {
            text: '新增',
            iconCls: 'wk wk-add',
            that: this,
            handler: function () {
              this.that.handlerMedicalDictInfo();
            }
          },
          {
            text: '删除',
            iconCls: 'wk wk-discard wk-danger',
            that: this,
            handler: function () {
              this.that.handlerMedicalDictDeleteBatch();
            }
          },
          {
            text: '同步公卫数据',
            iconCls: 'wk wk-success wk-down',
            that: this,
            handler: function () {
              this.that.handlerUpdatePhData();
            }
          },
          {
            text: '关闭',
            iconCls: 'wk wk-back',
            that: this,
            handler: function () {
              this.that.dialogVisible= false
            }
          },
        ],
        onDBClickRow: function(row) {}
      }
    };
  },
  computed: {
    currentTheme() {
      return this.$store.getters.themeType; //获取当前的主题类型
    },
    currentOrgId(){
      return localStorage.getItem("orgId");
    }
  },
  methods: {
    init(dictType) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.configure.listParam.dictType = dictType
        this.$refs.xrTable.getData();
      });
    },
    search() {
      this.$refs.xrTable.getData();
    },
    refreshData() {
      this.configure.listParam.dictLabel=''
      this.configure.listParam.status=''
      this.$refs.xrTable.getData();
      this.$emit('refreshParentData');
    },
    //新增
    handlerMedicalDictInfo(){
      this.isMedicalDictInfoShow = true;
      this.$nextTick(() => {
        this.$refs.medicalDictInfo.resetTemp();
        this.$refs.medicalDictInfo.init(this.configure.listParam.dictType,'add');
      })
    },
    //编辑
    handlerMedicalDictEdit(row){
      this.isMedicalDictInfoShow = true;
      this.$nextTick(() => {
        this.$refs.medicalDictInfo.resetTemp();
        this.$refs.medicalDictInfo.init(this.configure.listParam.dictType,'edit',row.dictCode);
      })
    },
    //删除
    handlerMedicalDictDelete(){
      this.$confirm(`确定要删除这条记录吗?`, '提示',
        {  confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
        return this.request({
          method:'post',
          url:'/web/service?method=tPhMedicalDict_delete',
          params: {
            'id': row.id
          }
        }).then((response) =>{
          if (response.code != '0') {
            this.$message.error(response.msg);
            return false;
          }
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.$refs.xrTable.getData();
              this.$emit('refreshParentData');
            }
          })
        })
      }).catch(() => {})
    },
    //批量删除
    handlerMedicalDictDeleteBatch(){
      let list = this.$refs.xrTable.multipleSelectionItem;
      let orgId = this.currentOrgId
      //判断是否选中
      if(list.length === 0){
        this.$message.warning("请选择需要删除的数据")
        return
      }
      const checkOrgId = list.every(item => {
         return item.orgId != orgId;
      });
      if (checkOrgId) {
          this.$message.warning("不能删除其它机构的数据，请重新选择！");
          return;
      }
      let ids = this.CommonUtils.createStrByList(list,'dictCode');

      this.$confirm(`确定要删除这些记录吗?`, '提示',
        {  confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
        return this.request({
          method:'post',
          url:'/web/service?method=tPhMedicalDict_delete',
          params: {
            'ids': ids
          }
        }).then((response) =>{
          if (response.code != '0') {
            this.$message.error(response.msg);
            return false;
          }
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.$refs.xrTable.getData();
              this.$emit('refreshParentData');
            }
          })
        })
      }).catch(() => {})
    },
    //同步公卫数据
    handlerUpdatePhData(){
      let dictType = this.configure.listParam.dictType
      if(!dictType){
        this.$message.warning("当前字段名称为空，不能同步数据！");
        return
      }
      return this.request({
        method:'post',
        url:'/web/service?method=tPhMedicalDict_downloadPhMedicalDictData',
        params: {
          'dictType': this.configure.listParam.dictType
        }
      }).then((response) =>{
        if (response.code != '0') {
          this.$message.error(response.msg);
          return false;
        }
        this.$message({
          message: '操作成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.$refs.xrTable.getData();
            this.$emit('refreshParentData');
          }
        })
      })
    }
  }
};
</script>

<style scoped>
.main-box {
  width: 100%;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/views/ph/dict/medical_dict_index.vue